export const DOCUMENT_CONTEXT_MENU_CATEGORY_KEY = 'base' as const;
export const DOCUMENT_CONTEXT_MENU_PARENT_COMPONENT_KEY = 'table' as const;
export const DOCUMENT_CONTEXT_MENU_COMPONENT_KEY = 'documentContextMenu' as const;
